import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private isShowingHeader$ = new BehaviorSubject<boolean>(true);

  headerState = {
    previous: {
      isShowingHeader: true
    },
    current: {
      isShowingHeader: true
    }
  }

  constructor() {

    if (sessionStorage['headerState'] != null) {
      this.headerState = JSON.parse(sessionStorage['headerState']);
      this.isShowingHeader$.next(this.headerState.current.isShowingHeader);
    }


    this.isShowingHeader$.subscribe((state: any) => {
      this.headerState = { previous: this.headerState.current, current: { isShowingHeader: state } };
      setTimeout(() => {
        sessionStorage['headerState'] = JSON.stringify(this.headerState);
      });
    });
  }

  shouldShowHeader() {
    return this.isShowingHeader$;
  }

  hideHeader() {
    this.isShowingHeader$.next(false);
  }

  showHeader() {
    this.isShowingHeader$.next(true);
  }

  restoreHeader() {
    this.isShowingHeader$.next(this.headerState.previous.isShowingHeader);
  }
}
